import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "defaultValue", "name", "onBlur", "onChange", "onFocus", "onValueChange", "options", "value"];

/** @jsx jsx */
import { jsx } from '@emotion/react';
import { useControlledState } from '@flowio/react-hooks';
import React from 'react';
import createRadioButton from '../createRadioButton';
import RadioButtonGroupContext from '../RadioButtonGroupContext';

var RadioButtonGroup = function RadioButtonGroup(_ref) {
  var children = _ref.children,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      name = _ref.name,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      onValueChange = _ref.onValueChange,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [] : _ref$options,
      value = _ref.value,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  var _useControlledState = useControlledState(value, defaultValue, onValueChange),
      _useControlledState2 = _slicedToArray(_useControlledState, 2),
      selectedValue = _useControlledState2[0],
      setSelectedValue = _useControlledState2[1];

  var handleChange = React.useCallback(function (event) {
    setSelectedValue(event.currentTarget.value);

    if (typeof onChange === 'function') {
      onChange(event);
    }
  }, [onChange, setSelectedValue]);
  var context = {
    name: name,
    onBlur: onBlur,
    onChange: handleChange,
    onFocus: onFocus,
    value: selectedValue
  };
  return jsx(RadioButtonGroupContext.Provider, {
    value: context
  }, jsx("div", unhandledProps, children != null ? children : options.map(function (option, index) {
    return createRadioButton(option, {
      defaultProps: {
        childKey: index
      }
    });
  })));
};

RadioButtonGroup.displayName = 'RadioButtonGroup';
export default RadioButtonGroup;